var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_apps",
    transform: "translate(-1389 -1978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(1389 1978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M40.5,81A40.5,40.5,0,1,1,81,40.5,40.546,40.546,0,0,1,40.5,81Zm0-76.14A35.64,35.64,0,1,0,76.14,40.5,35.68,35.68,0,0,0,40.5,4.86Z",
    fill: "#01358d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobile-marketing_1_",
    "data-name": "mobile-marketing (1)",
    transform: "translate(1404.886 1995.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    transform: "translate(13.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5333",
    "data-name": "Path 5333",
    d: "M339.318,122.6l-.912.377a5.475,5.475,0,0,0-1.074-1.072l.378-.915a.544.544,0,0,0-.294-.71l-1.5-.624a.543.543,0,0,0-.709.294l-.382.915a5.434,5.434,0,0,0-1.517,0l-.377-.911a.537.537,0,0,0-.7-.3l-1.505.623a.537.537,0,0,0-.287.707l.377.911a5.46,5.46,0,0,0-1.072,1.075l-.915-.378a.544.544,0,0,0-.711.294l-.624,1.505a.543.543,0,0,0,.293.709l.915.381a5.489,5.489,0,0,0,0,1.518l-.911.377a.538.538,0,0,0-.3.7l.623,1.5a.537.537,0,0,0,.707.288l.912-.377a5.471,5.471,0,0,0,1.074,1.073l-.377.915a.544.544,0,0,0,.294.711l1.5.624a.543.543,0,0,0,.71-.293l.382-.915a5.491,5.491,0,0,0,1.518,0l.377.912a.537.537,0,0,0,.7.3l1.5-.623a.538.538,0,0,0,.288-.707l-.377-.911A5.493,5.493,0,0,0,338.4,129.5l.915.378a.544.544,0,0,0,.71-.294l.624-1.5a.543.543,0,0,0-.293-.71l-.915-.382a5.439,5.439,0,0,0,0-1.517l.911-.377a.537.537,0,0,0,.3-.7l-.623-1.5A.537.537,0,0,0,339.318,122.6Zm-4.213,6.146a2.715,2.715,0,1,1,1.469-3.547A2.714,2.714,0,0,1,335.105,128.745Z",
    transform: "translate(-310.539 -108.29)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5334",
    "data-name": "Path 5334",
    d: "M171.054,26.01v12H151.146V7.692h19.908v2.18h2.262V3.62A3.62,3.62,0,0,0,169.7,0H152.5a3.62,3.62,0,0,0-3.62,3.62V41.625a3.62,3.62,0,0,0,3.62,3.62H169.7a3.62,3.62,0,0,0,3.62-3.62V26.01ZM159.306,4.072h3.62a.452.452,0,1,1,0,.9h-3.62a.452.452,0,1,1,0-.9ZM160.964,43.1a1.81,1.81,0,1,1,1.81-1.81A1.81,1.81,0,0,1,160.964,43.1Z",
    transform: "translate(-148.884)",
    fill: "#f9556d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 10.859,
    height: 2.262,
    transform: "translate(0 11.55)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 8.144,
    height: 2.262,
    transform: "translate(2.715 16.074)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 2.715,
    height: 2.262,
    transform: "translate(8.144 20.599)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1600",
    "data-name": "Ellipse 1600",
    transform: "translate(1452.729 1990)",
    fill: "#f9556d",
    stroke: "#fff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0539d249439c170c4c699c4ac230ccad.svg";
export { ForwardRef as ReactComponent };